import { motion } from "framer-motion";
import { Share2 } from "lucide-react";

export const MessageBubble = ({ role, text, streaming, stopped, onShare, shareDisabled }) => {
  const isUser = role === "user";
  return (
    <motion.div
      initial={{ opacity: 0, y: 12, scale: 0.98 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ duration: 0.25, ease: "easeOut" }}
      className={`group flex items-start gap-3 ${isUser ? "justify-end" : "justify-start"}`}
    >
      {!isUser && <div className="avatar" aria-hidden>ALT</div>}
      {!isUser && text === "" ? (
        <div data-testid="typing-indicator" className="bubble bubble-alter flex items-center gap-1.5 py-4">
          <span className="dot" /><span className="dot" /><span className="dot" />
        </div>
      ) : (
        <div className={`flex flex-col gap-1.5 ${isUser ? "items-end" : "items-start"} max-w-[80%]`}>
          <div
            data-testid={isUser ? "user-message-bubble" : "alter-ego-message-bubble"}
            className={`bubble !max-w-full ${isUser ? "bubble-user" : "bubble-alter"} ${streaming && !isUser ? "caret" : ""}`}
          >
            {text}
          </div>
          {!isUser && !streaming && (
            <div className="flex items-center gap-3 pl-1">
              {stopped && (
                <span data-testid="stopped-label" className="font-mono text-[11px] text-[#64748b] tracking-wide">stopped</span>
              )}
              {onShare && (
                <button
                  type="button"
                  data-testid="share-snapshot-button"
                  className="share-btn"
                  onClick={onShare}
                  disabled={shareDisabled}
                >
                  <Share2 size={12} /> Share snapshot
                </button>
              )}
            </div>
          )}
        </div>
      )}
    </motion.div>
  );
};
